/*
 Top level component, it renders everything else
 */

import React, {useEffect} from 'react';

import { useSelector, useDispatch } from "react-redux";

import NavBar from './NavBar';
import ProjectDetails from './ProjectDetails';
import IKnowMyPartNumber from './IKnowMyPartNumber';
import ProductSelector from "./steps/ProductSelectorStep";
import PatternSelector from "./steps/patterns/PatternSelectorStep";
import StepCount from "./steps/StepCounter";

import Notice from "./Notice";

import Summary from "./steps/Summary";
import PatternSummary from "./steps/patterns/PatternSummary";
import SummaryError from "./steps/SummaryError";

import StepByStep from "./StepByStep";

import APIService from "./services/APIService";
import ProductImage from "./ProductImage";
import {familyVersionsSet, loadProducts} from "../store/product/productsSlice";
import {
    loadElementQuoteItem,
    loadPatternConfiguration,
    loadQuoteItem,
    runPartNumberLookup
} from "../store/product/productDataSlice";
import {
    getQuoteData,
    setElementGroupId,
    setLineNumberForNewQuoteItem,
    setQuoteId,
    setQuoteItemId
} from "../store/details/projectDetailsSlice";
import {setGroupId} from "../store/details/patternDetailsSlice";
import {getAgent, setCurrentUrl, setElementSaveShouldUpdate, setPatternEditType} from "../store/configuratorStateSlice";
import ProductElementsStep from "./steps/ProductElementsStep";

const Configurator = (props) => {
    const dispatch = useDispatch();
    const product = useSelector(state => state.productDataReducer);
    const isPattern = useSelector(state => state.configuratorStateReducer.isPattern);

    const showSummary = useSelector(state => state.configuratorStateReducer.displayOptionalAndSummary)
    const showPatternSummary = useSelector(state => state.configuratorStateReducer.displayPatternSummary)

    const errors = useSelector(state => state.configuratorStateReducer.errors);
    const hasElements = useSelector(state => state.configuratorStateReducer.hasElements);

    useEffect(() => {
        const initializeQuoteBuilder = async () => {
            await dispatch(getAgent());
            await setQuoteDetails(); // this is needed to save quote and quote_item from url
        }
        initializeQuoteBuilder();
        dispatch(loadProducts(props.products))
        // needed in store to keep track of save + copy status
        dispatch(setCurrentUrl(window.location.href));
    }, [])




    const setQuoteDetails = async () => {
        // here we have our mini router, we are guessing based on certain params
        // which URL it is and based on that doing necessery actions
        let quoteId = /quotes\/(\d+)\//.exec(window.location.href);
        let quoteItemId = /quote_items\/(\d+)\//.exec(window.location.href);
        let groupEdit =  /.*\/quote_items\/[a-zA-Z0-9].*\/edit/.exec(window.location.href);
        const elementEdit = /quote_items\/(\d+)\/edit_element/.exec(window.location.href);
        let catalog_lookup = /.*quote_items\/new\/[a-zA-Z0-9].*/.exec(window.location.href);
        let patternLookupByQuoteItem = /.*quote_items\/new\?template_item_id=[a-zA-Z0-9].*/.exec(window.location.href);
        let copyElement = /.*quote_items\/new\?template_group_id=[0-9].*/.exec(window.location.href);
        let addingProduct = /.*\/quote_items\/new/.exec(window.location.href);
        // This is when we have quote item, so we are saving the quoteitemID
        if(quoteId) {
            dispatch(setQuoteId(quoteId[1]));
            await dispatch(getQuoteData(quoteId[1]));
        }

        if(addingProduct){
            dispatch(setLineNumberForNewQuoteItem())
        }

        if(quoteItemId && !elementEdit) {
            dispatch(setQuoteItemId(quoteItemId[1]));
            await dispatch(loadQuoteItem());
        }else if (quoteItemId && elementEdit) {
            dispatch(setElementGroupId(quoteItemId[1]));
            await dispatch(loadElementQuoteItem());
            dispatch(setElementSaveShouldUpdate(true));
        // this is for editing groups URLS like:
        // /quotes/45705/quote_items/7d9fb83d-9ba5-46d5-8265-2e071c30efb5/edit
        } else if(groupEdit) {
            // if there is no quote item Edit it is either a 'new
            // or it is pattern with its group id instead of 123 it has blah-blah-blah
            // so we need to handle it differently
            let quoteItemGroup =  /quote_items\/([a-z0-9\-._~%!$&'()*+,;=:@/]*)\//.exec(window.location.href);
            if (quoteItemGroup){
                dispatch(setGroupId(quoteItemGroup[1]));
                dispatch(setPatternEditType('group'))
                dispatch(loadPatternConfiguration())
            }

            // this is use case for Editing products with URLS like this :
            //   quotes/45701/quote_items/new/PF1PDB35A08DF2M06
            // this handles copy quote item
        } else if(catalog_lookup) {
            // grab a catalog
            let catalog_number = window.location.href.split('/').pop(-1);
            dispatch(runPartNumberLookup(catalog_number))
        } else if(patternLookupByQuoteItem){
            let quote_item_id = window.location.href.split('=').pop(-1);
            dispatch(setQuoteItemId(quote_item_id));
            dispatch(setPatternEditType('quoteItemId'))
            dispatch(loadPatternConfiguration())
        } else if(copyElement) {
            let elementGroupId = window.location.href.split('=').pop(-1);
            dispatch(setElementGroupId(elementGroupId));
            dispatch(loadElementQuoteItem(true));
            dispatch(setElementGroupId(""));
            dispatch(setElementSaveShouldUpdate(false));
            dispatch(setQuoteItemId(""));
        }
    }

    /*
       This is to display Small step counter at the bottom
     */
    const displayCounter = () => {
        // it starts after the product is selected
        if(product != null) {
            return <StepCount />
        }
    }

    // choose between regular summary and pattern summary
    const displayAfterSteps = () => {
        if(showSummary && hasElements){
            return <ProductElementsStep />
        } else if(showSummary && !isPattern && errors.length == 0){
            return <Summary />
        } else if(isPattern && showPatternSummary && errors.length == 0) {
            return <PatternSummary/>;
        } else {
            // when displaying nothing we also want to clear notices
            dispatch({type: 'CLEAR_NOTICES'});
            return '';
        }
    }

    const displayDetailsTitle = () => {
        if(product && product.id ){
            return(
                <div className="small-12 columns details-wrapper">
                  <h2>Features</h2>
                </div>
            )
        }
    }

    // const title = props.title;
    return (
        <div>
            <form  id="quote-builder">
                <div id="configurator_main">
                    <Notice />
                    <div className="configurator-details-wrapper">
                        <div className="row">
                            <div className="small-12 columns order-details-cfg">
                                <div className="panel">
                                    <div className="project-details">

                                        <ProjectDetails currencies={props.currencies} languages={props.languages}></ProjectDetails>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <NavBar />
                    <div className="row">
                        <div className="small-12 medium-9 medium-offset-3 columns">
                        </div>
                    </div>
                    <div className="row">
                        <IKnowMyPartNumber products={props.products}></IKnowMyPartNumber>
                        <ProductSelector products={props.products} categories={props.categories}></ProductSelector>
                        <PatternSelector />

                        { displayDetailsTitle() }
                        <div className="small-12 columns">
                            <ProductImage></ProductImage>
                        </div>
                        <div className="small-12 columns order-details-cfg">
                            <div id="steps">
                                <StepByStep product={product} isPattern={isPattern}/>
                                { displayCounter() }
                            </div>
                        </div>
                    </div>
                    { displayAfterSteps() }
                    <SummaryError />
                </div>
            </form>
        </div>

    )

}
export default Configurator;